import startMic from './startMic.mp3';
import stopMic from './stopMic.mp3';

export const SOUNDS = {
  startMic,
  stopMic,
};